<div
  class="modal-header bg-head py-2 d-flex justify-content-between align-items-center"
>
  <h6 class="modal-title mb-0">Change Main Topic Display Order</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>
<div class="row">
  <div class="col-12 headersize py-2">
    <span class="px-4 my-2 path-class"> {{ path }}</span>
  </div>
</div>
<hr class="mt-0" />
<div class="modal-body m-body pt-0 px-0" cdkScrollable #scrollArea>
  <div class="">
    <div class="pt-0 p-4">
      <table class="table table-fixed" [formGroup]="displayForm">
        <thead class="">
          <tr>
            <th class="text-center fw-medium border-0" style="width: 5%">
              Main Topic ID
            </th>

            <th class="text-center fw-medium border-0" style="width: 8%">
              Main Topic Name
            </th>
            <th class="text-center fw-medium border-0" style="width: 18%">
              Course Name
            </th>
            <th class="text-center fw-medium border-0" style="width: 8%">
              Exam Name
            </th>
            <th class="text-center fw-medium border-0" style="width: 6%">
              Exam Year
            </th>
            <th class="text-center fw-medium border-0" style="width: 6%">
              Main Topic Status
            </th>
            <th class="text-center fw-medium border-0" style="width: 15%">
              Major Topic
            </th>
            <th class="text-center fw-medium border-0" style="width: 5%">
              Display Order
            </th>
            <th class="text-center fw-medium border-0" style="width: 5%"></th>
          </tr>
        </thead>
        <tbody
          formArrayName="sortOrder"
          cdkDropList
          (cdkDropListDropped)="drop($event)"
        >
        <ng-container *ngFor="let item of DisplayArray.controls; let i = index" >
          <tr
            *ngIf="item.value.deleteInd ==='N'"
            [formGroupName]="i"
            cdkDrag
            class="example-box border-bottom-0"
          >
            <td class="border-bottom-0">
              <div class="custom-input text-end">
                {{ item.value.courseMainTopicId }}
              </div>
            </td>

            <td class="border-bottom-0">
              <div
                class="custom-input text-start"
                [title]="item.value.courseMainTopicName"
              >
                {{ item.value.courseMainTopicName }}
              </div>
            </td>
            <td class="border-bottom-0">
              <div
                class="custom-input text-start"
                [title]="item.value.courseName"
              >
                {{ item.value.courseName }}
              </div>
            </td>
            <td class="border-bottom-0">
              <div
                class="custom-input text-start"
                [title]="item.value.ExamAgencyName"
              >
                {{ item.value.ExamAgencyName }}
              </div>
            </td>
            <td class="border-bottom-0">
              <div class="custom-input text-start">
                {{ item.value.examYear }}
              </div>
            </td>

            <td class="border-bottom-0">
              <div class="custom-input text-start">
                {{ item.value.courseMainTopicStatusTypeCode }}
              </div>
            </td>
            <td class="border-bottom-0">
              <div class="custom-input ">
                {{ item.value.majorTopicName }}
              </div>
            </td>
            <td class="border-bottom-0">
              <div class="custom-input text-end">
                {{ item.value.displayOrder }}
              </div>
            </td>
            <td class="border-bottom-0">
              <div
                class="custom-input-edit text-center"

              >
                <i class="fa fa-pencil" (click)="edit(item.value)"></i>
                <i class="fa fa-trash ms-2" (click)="deleteTopic(item.value,i)"></i>
              </div>
            </td>
          </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-footer d-flex justify-content-end gap-2">
  <button type="button" class="bl-btn btn btn-sm px-3" (click)="onSave()">
    Save
  </button>
  <button
    type="button"
    class="btn btn-sm bg-light border px-3"
    (click)="onCross()"
  >
    Cancel
  </button>
</div>
